import type { RenewalSummary } from '@policyvision/contracts';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

import useLastRefreshedAt from '@/common/hooks/useLastRefreshedAt';
import { createDefaultPaginated } from '@/common/types/paginated';

import {
  fetchPaginatedRenewalsSummary,
  RenewalPaginationParams,
} from '../api/FetchRenewalList';
import { Filters } from '../types/FilterTypes';

export const useFetchPaginatedRenewalList = (
  pagination: RenewalPaginationParams,
  filters?: Filters,
) => {
  const { data, isLoading, error, refetch, dataUpdatedAt } = useQuery({
    queryKey: ['renewals', pagination, filters],
    queryFn: ({ signal }) =>
      fetchPaginatedRenewalsSummary(pagination, filters, signal),
    throwOnError: true,
    placeholderData: keepPreviousData,
    refetchInterval: 30000,
  });

  const lastRefreshedAt = useLastRefreshedAt(dataUpdatedAt);

  const paginatedRenewals = data || createDefaultPaginated<RenewalSummary>();

  return {
    paginatedRenewals,
    isLoading,
    error,
    refetch,
    lastRefreshedAt,
  };
};
